require('../../modules/es6.string.code-point-at');
module.exports = require('../../modules/_core').String.codePointAt;



// WEBPACK FOOTER //
// webpack://pdfjs-dist/build/pdf/node_modules/core-js/fn/string/code-point-at.js